import { AnalyticsStore } from 'bernie-core';
import { trackAnalytics } from 'utility/analytics';
import { ClientMetadataStore } from 'stores';
import { AnalyticsType } from 'types/shared';

export const setPageTitle = (clientMetadataStore: ClientMetadataStore, analytics: AnalyticsStore) => {
  const pageName = clientMetadataStore.pageName;
  const analyticsType: AnalyticsType = clientMetadataStore && clientMetadataStore.pageNameAnalytics;
  if (pageName && analyticsType) {
    document.title = pageName;
    trackAnalytics(analyticsType, analytics);
  }
};
